import Vue from 'vue';
import dayjs from 'dayjs';
import { StatoLavorazione, Azione } from '@/models';
import { StatoSpedizione } from '@/models/enums/StatoSpedizioni';

Vue.filter('formatDate', function (date: any) {
    if(date) {
        return dayjs(date).format('DD/MM/YYYY');
    }
    return '';
});

Vue.filter('formatDateTime', function (date: any) {
    if(date) {
        return dayjs(date).format('DD/MM/YYYY HH:mm');
    }
    return '';
});

Vue.filter('formatTime', function (date: any) {
    if(date) {
        return dayjs(date).format('HH:mm');
    }
    return '';
});

Vue.filter('formatNumber', function (value: any) {
    return (+value).toFixed(2).replace(".",",");
});

Vue.filter('statoLavorazioneDesc', function (stato: StatoLavorazione) {
    switch(stato) {
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE: return 'Valutazione fornitore';
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_BC: return 'Valutazione BC';
        case StatoLavorazione.ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE: return 'Preparazione consegna';
        case StatoLavorazione.CONSEGNATO_A_FORNITORE: return 'In consegna';
        case StatoLavorazione.CONSEGNA_A_FORNITORE_PROCESSATA: return 'Consegna confermata';
        case StatoLavorazione.IN_CORSO_DI_LAVORAZIONE: return 'In lavorazione';
        case StatoLavorazione.COMPLETATO_IN_ATTESA_DI_RIENTRO: return 'Completato';
        case StatoLavorazione.RIENTRATO: return 'In rientro';
        case StatoLavorazione.RIENTRO_PROCESSATO: return 'Chiuso';
    }
    return stato;
});

Vue.filter('statoSpedizioneDesc', function (stato: StatoSpedizione) {
    switch(stato) {
        case StatoSpedizione.NUOVA: return 'Nuove';
        case StatoSpedizione.COMPLETA: return 'Complete';
        case StatoSpedizione.SPEDITA: return 'Spedite';
        default: return '';
    }
});

Vue.filter('statoLavorazioneDescBreve', function (stato: StatoLavorazione) {
    switch(stato) {
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE: return 'Valutazione';
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_BC: return 'Val. BC';
        case StatoLavorazione.ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE: return 'Preparazione';
        case StatoLavorazione.CONSEGNATO_A_FORNITORE: return 'In consegna';
        case StatoLavorazione.CONSEGNA_A_FORNITORE_PROCESSATA: return 'Confermata';
        case StatoLavorazione.IN_CORSO_DI_LAVORAZIONE: return 'Lavorazione';
        case StatoLavorazione.COMPLETATO_IN_ATTESA_DI_RIENTRO: return 'Completato';
        case StatoLavorazione.RIENTRATO: return 'Rientro';
        case StatoLavorazione.RIENTRO_PROCESSATO: return 'Chiuso';
    }
    return stato;
});

Vue.filter('statoLavorazioneIco', function (stato: StatoLavorazione) {
    switch(stato) {
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE: return 'mdi-forum';
        case StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_BC: return 'mdi-forum';
        case StatoLavorazione.ACCETTATO_IN_ATTESA_DI_CONSEGNA_A_FORNITORE: return 'mdi-truck';
        case StatoLavorazione.CONSEGNATO_A_FORNITORE: return 'mdi-truck';
        case StatoLavorazione.CONSEGNA_A_FORNITORE_PROCESSATA: return 'mdi-thumb-up';
        case StatoLavorazione.IN_CORSO_DI_LAVORAZIONE: return 'mdi-wrench';
        case StatoLavorazione.COMPLETATO_IN_ATTESA_DI_RIENTRO: return 'mdi-truck';
        case StatoLavorazione.RIENTRATO: return 'mdi-truck';
        case StatoLavorazione.RIENTRO_PROCESSATO: return 'mdi-check-bold';
    }
    return stato;
});

Vue.filter('azioneLavorazioneDesc', function (azione: Azione) {
    switch(azione) {
        case Azione.ACCETTA: return 'Accetta';
        case Azione.FORZA_ACCETTAZIONE_DA_PARTE_DI_BC: return 'Forza accettazione BC';
        case Azione.AGGIORNA_LAVORAZIONE: return 'Aggiorna dati';
        case Azione.CONSEGNA_A_FORNITORE: return 'Invia a fornitore';
        case Azione.REGISTRA_CONSEGNA_A_FORNITORE: return 'Conferma ricezione';
        case Azione.FORZA_CONSEGNA_A_FORNITORE_DA_PARTE_DI_BC: return 'Forza invio BC';
        case Azione.INIZIA_LAVORAZIONE: return 'Avvia lavorazione';
        case Azione.COMPLETA_LAVORAZIONE: return 'Completa';
        case Azione.REGISTRA_RIENTRO: return 'Registra rientro';
        case Azione.RICHIEDI_VARIAZIONE: return 'Richiedi variazione';
        case Azione.RICONSEGNA_A_BC: return 'Invia a BC';
    }
    return azione;
});

Vue.filter('statoOrdineIco', function (stato: string) {
    switch(stato) {
        case "NUOVO": return 'mdi-forum';
        case "APERTO": return 'mdi-wrench';
        case "COMPLETATO": return 'mdi-check-bold';
    }
    return stato;
});

Vue.filter('statoOrdineMTMIco', function (stato: string) {
    switch(stato) {
        case "IN LAVORAZIONE": return 'mdi-forum';
        case "ORDINE INSERITO": return 'mdi-wrench';
        case "ANAGRAFICA INSERITA": return 'mdi-check-bold';
        case "CONSEGNA CHIUSA": return 'mdi-check-bold';
        default: return 'mdi-check-bold';
    }
    return null;
});